import { classnames } from '@aibees/shared/utils';
import { Tooltip } from '@mui/material';
import { memo } from 'react';
import { Icon } from '../icon';
import * as Styled from './styles';
import type { IconButtonProps as Props } from './types';

// TODO use this IconButton everywhere (find the materialUI ones in the code replace them with this one)
export const IconButton = memo(
  ({
    icon,
    iconColor,
    iconSize,
    title,
    tooltipTitle,
    className,
    sx,
    ...othereProps
  }: Props) => {
    return (
      <Tooltip title={tooltipTitle}>
        <Styled.Wrapper
          className={classnames('IconButton', className, { round: !title })}
          sx={{
            ...sx,
          }}
          {...othereProps}
        >
          {title || ''}
          {icon && <Icon name={icon} color={iconColor} size={iconSize} />}
        </Styled.Wrapper>
      </Tooltip>
    );
  }
);

IconButton.displayName = 'IconButton';
